<template>

  <span class="wrap">
	{{settings.avg_cpc.value}}
	<div class="overlay">
		<span
			v-for="(opt, optionIndex) in options" 
			:key="optionIndex"
		>
			<span><span class="type" v-html="opt.label+':'" /> <span class="value" v-html="opt.value" /> <span class="full" v-html="opt.title" /> </span>
		</span>
	</div>
  </span>

</template>

<script>
export default {
  name: 'TableCPC',
  props: ['settings'],
  data() {
  return {
    
  }
  },
  computed: {

   options () {

      let r = [
		{ label: 'Avg CPC', type: 'avg_cpc', value: 'Unknown', title: 'Unknown' },
		{ label: 'Lowest Bid', type: 'low_t_o_p_bid', value: 'Unknown', title: 'Unknown' },
		{ label: 'Highest Bid', type: 'high_t_o_p_bid', value: 'Unknown', title: 'Unknown' }
	  ];

	  r.forEach(function(opt,i) {

		if ( this.settings[opt.type] ) {

			r[i].value = this.settings[opt.type].value;
			r[i].title = this.settings[opt.type].title;

		}

	  }.bind(this));

	  return r;

    }

  },
  methods: {
  
    clicked(e) {

      

    }

  },
  created() {
	
  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.wrap {
	display: inline-block;
	position: relative;
	.overlay {

		position: absolute;
		display: none;
		background-color: #fff;
		z-index: 2;
		top: 0px;
		left: 0;
		cursor: default;
		padding: 5px;
		width: 150px;

		> span {

			display: inline-block;
			padding-top: 2px;
			font-size: 12px;

			&:first-child {

				padding-top: 0;

			}

			.type {

				font-weight: @bold;

			}

			.full {

				display: none;;

			}

			&:hover {

				.full {

					display: inline;

				}

				.value {

					display: none;

				}

			}
				
		}

	}
	&:hover {
		.overlay {
			display: block;
		}
	}
}
</style>